import { configureStore } from '@reduxjs/toolkit';
import communityReducer from './slices/communitySlice';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import marketplaceReducer from './slices/marketplaceSlice';
import teachersReducer from './slices/teachersSlice';
import classesReducer from './slices/classesSlice';
import profileReducer from './slices/profileSlice';
import notificationsReducer from './slices/notificationSlice';

/**
 * Redux Store
 *
 * Slices:
 *  - auth        → Login, Register, User Profile     (api/auth.js)
 *  - community   → Communities, Categories           (api/communities.js)
 *  - marketplace → Courses, Recommended, Trending    (api/marketplace.js)
 *  - teachers    → Teacher Listing, Teacher Detail   (api/teachers.js)
 *  - classes     → Public Classes, Bookings          (api/classes.js)
 *  - profile     → Account Management (Teacher+Student) (api/profile.js)
 *  - ui          → Sidebar, Theme, Notifications, Toast
 *  - notifications → User Notifications               (api/notifications.js)
 */
const store = configureStore({
  reducer: {
    auth: authReducer,
    community: communityReducer,
    marketplace: marketplaceReducer,
    teachers: teachersReducer,
    classes: classesReducer,
    profile: profileReducer,
    ui: uiReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
